import {Component} from '@angular/core';
import {slideFromToRightTrigger} from './animations/slide';
import {MessengerService} from './messenger.service';

@Component({
    selector: 'kkk-messenger',
    templateUrl: './messenger.component.html',
    animations: [
        slideFromToRightTrigger
    ]
})
export class MessengerComponent {
    constructor(public service: MessengerService) {
    }
}



// WEBPACK FOOTER //
// /Users/manuel/Development/kkk/frontend/src/app/messenger/messenger.component.ts